<template>
  <!-- Multi-select routes through BaseFilterSelect for the sticky
       "Select all / Clear all" header (same as the organization filter).
       Single-select keeps the plain v-select. -->
  <base-filter-select
      v-if="isMultiple"
      v-model="model"
      :options="options"
      label="name"
      :reduce="(bu) => bu.id"
      multiple
      :clearable="clearable"
      :select-props="mergedSelectProps"
      :placeholder="placeholder"
  >
    <template #option="option">
      <div v-if="option._isGroup" class="desk-opt-header">{{ option.name }}</div>
      <span v-else><span :class="option.type"></span>{{ option.name + ' - ' + option.type }}</span>
    </template>
  </base-filter-select>

  <v-select
      v-else
      v-model="model"
      :options="options"
      label="name"
      :reduce="(bu) => bu.id"
      v-bind="selectProps"
      v-bind:readonly="readonly"
      v-bind:disabled="disabled"
      :selectable="opt => !(opt && opt._isGroup)"
      :placeholder="placeholder"
  >
    <template v-slot:option="option">
      <div v-if="option._isGroup" class="desk-opt-header">{{ option.name }}</div>
      <span v-else><span :class="option.type"></span>{{ option.name + ' - ' + option.type }}</span>
    </template>
  </v-select>
</template>

<script>
import { mapGetters } from 'vuex'
import { isEmptyList, groupItemsByDesk } from '@/model/Utils'
import BaseFilterSelect from '@/components/widget/select/BaseFilterSelect.vue'

export default {
  name: 'BusinessUnitSelectBox',
  components: { BaseFilterSelect },
  props: {
    value: {
      required: true,
      multiple:{
        default:()=>false
      }
    },
    selectedOrganization: {
      required: false,
      default: ()=> []
    },
    selectedDepartment: {
      required: false,
      default: ()=> []
    },
    selectProps:{
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    clearable:{
      type: Boolean,
      default: () => false
    },
    multiple:{
      type: Boolean,
      default: () => false
    },
    placeholder:{
      type: String,
      default: () => ''
    }
  },
  watch:{
    selectedOrganization(){
      this.validateFilter();
    },
    selectedDepartment(){
      this.validateFilter();
    }
  },
  computed:{
    ...mapGetters('data', ['allBusinessUnits', 'getBusinessUnitById', 'allOrganizations']),
    isMultiple(){
      return this.multiple || this.selectProps?.multiple === true
    },
    // BaseFilterSelect forwards selectProps onto the underlying vue-select, so
    // disabled/readonly/selectable are passed through here (matches OrganizationSelectBox).
    mergedSelectProps(){
      return {
        ...this.selectProps,
        disabled: this.disabled || this.selectProps?.disabled === true,
        readonly: this.readonly || this.selectProps?.readonly === true,
        selectable: opt => !(opt && opt._isGroup),
      }
    },
    options(){
      let options = this.allBusinessUnits;
      if(!isEmptyList(this.selectedOrganization)){
        options =  options.filter((bu) => {
          return this.selectedOrganization.includes(bu.orgId);
        });
      }
      if(!isEmptyList(this.selectedDepartment)){
        options =  options.filter((bu) => {
          return this.selectedDepartment.includes(bu.type);
        });
      }
      // group business units under their organization's desk
      const deskByOrg = {};
      (this.allOrganizations || []).forEach(o => { deskByOrg[o.id] = o.desk; });
      return groupItemsByDesk(options, bu => deskByOrg[bu.orgId], bu => bu.name);
    },
    model:{
      get(){
        return this.value;
      },
      set(value){
        this.$emit('input',value);
      }
    },
    _selectProps(){
      let props = {...this.$props, ...this.selectProps}
      delete props.value
      delete props.options
      delete props.label
      delete props.reduce
      return props
    }
  },
  methods:{
    getFullDesctiption(bu){
      return `${bu.name} -  ${bu.type}`
    },
    validateFilter(){
      console.log('validateFilter')
      if(isEmptyList(this.value)){
        return
      }
      let filter = this.value.map(buid=>this.getBusinessUnitById(buid))
      if(!isEmptyList(this.selectedOrganization)) {
        filter = filter.filter((bu) => {
          return this.selectedOrganization.includes(bu.orgId)
        })
      }
      if(!isEmptyList(this.selectedDepartment)) {
        filter = filter.filter((bu) => {
          return this.selectedDepartment.includes(bu.type)
        })
      }
      if (isEmptyList(filter)) {
        this.$emit('input', [])
      }else {
        this.$emit('input', filter.map(bu=>bu.id))
      }
    }
  }
}
</script>

<style scoped>

</style>
